import { cookieNames } from "../config";
import { doesCookieExist } from "./cookies";

/**
 * @title Initialise Tracking Scripts
 * @description Logic for handling SEOMatic Tracking Scripts with Blitz
 */
export function initialiseTrackingScripts() {
	const cookie = doesCookieExist(cookieNames.cookiesAccepted);

	if (cookie && cookie === true) {
		fetch("/get-tracking-scripts", {
			method: "get",
		})
			.then((response) => response.json())
			.then((response) => {
				if (response) {
					// response = JSON.parse(response);
					const headScripts = document.createRange().createContextualFragment(response.script);
					// const bodyScripts = document.createRange().createContextualFragment(response.bodyScript);

					document.head.appendChild(headScripts);
					// document.body.prepend(bodyScripts);
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
}
